import type { ReactNode } from 'react'

/** Consistent vertical rhythm. Generous whitespace is most of "premium". */
export function Section({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <section className={`py-24 lg:py-28 ${className}`}>
      <div className="mx-auto max-w-6xl px-5 lg:px-8">{children}</div>
    </section>
  )
}

export function SectionHead({
  eyebrow,
  title,
  intro,
  center = false,
}: {
  eyebrow: string
  title: ReactNode
  intro?: string
  center?: boolean
}) {
  return (
    <header className={center ? 'text-center' : 'max-w-2xl'}>
      <p className={`eyebrow ${center ? 'justify-center' : ''}`}>{eyebrow}</p>
      <h2 className="h-display mt-5 text-3xl leading-tight sm:text-[2.6rem]">{title}</h2>
      {intro && <p className="lead mt-6">{intro}</p>}
    </header>
  )
}
